"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useKeyUpdateRatings = void 0;
exports.updateRatingsSetMock = updateRatingsSetMock;
exports.updateRatings = updateRatings;
exports.useMutationUpdateRatings = useMutationUpdateRatings;
const gateway_core_1 = require("@ifit/gateway-core");
const is_down_1 = require("./is-down");
let setMock;
let reactQuery;
function updateRatingsSetMock(mock) {
    setMock = mock;
}
async function updateRatings(body, params) {
    if (!params) {
        params = {};
    }
    if (setMock) {
        return setMock(body, params);
    }
    const client = params.client || (0, gateway_core_1.getDefaultClient)();
    if (!client) {
        throw new Error('No @ifit/gateway-core GatewayApiClient has been constructed yet! Please do so before calling gateway methods, or pass a compatible client in the parameters.');
    }
    const requestURL = `/workout-store/v2/workouts/${params.id}/ratings`;
    const requestConfig = params.useM2MAuth
        ? await client.getM2MRequestConfig(params)
        : client.getRequestConfig(params);
    const headers = Object.assign(Object.assign({}, requestConfig.headers), params.headers);
    const queryParams = Object.assign({}, requestConfig.params);
    if (params['X-Llama-Namespaces'] !== undefined) {
        headers['X-Llama-Namespaces'] = params['X-Llama-Namespaces'];
    }
    if (params['X-Llama-Log-Level'] !== undefined) {
        headers['X-Llama-Log-Level'] = params['X-Llama-Log-Level'];
    }
    if (params['Cache-Control'] !== undefined) {
        headers['Cache-Control'] = params['Cache-Control'];
    }
    if (params.Accept !== undefined) {
        headers.Accept = params.Accept;
    }
    if ((params.forceStatusCheck) && (await (0, is_down_1.workoutStoreIsDown)(client))) {
        return null;
    }
    const response = await client.req.send(requestURL, Object.assign(Object.assign({}, requestConfig), { data: body, headers, method: 'PUT', params: queryParams }), params);
    return params.returnResponse
        ? response
        : response.data;
}
exports.useKeyUpdateRatings = 'workout-store:updateRatings:put';
function useMutationUpdateRatings(mutationOptions) {
    if (!reactQuery) {
        reactQuery = require('react-query');
    }
    return reactQuery.useMutation(mutationFn, Object.assign({ mutationKey: exports.useKeyUpdateRatings }, mutationOptions));
}
function mutationFn({ body, params }) {
    const promise = updateRatings(body, params);
    if (params === null || params === void 0 ? void 0 : params.cancelSource) {
        promise.cancel = () => {
            params.cancelSource.cancel('Query was cancelled by React Query');
        };
    }
    return promise;
}
//# sourceMappingURL=update-ratings.js.map